import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButtonSvgIcon } from './IconProvider';
import ImageLoader from './ImageLoader';

const VerificationFailed = ({
  kycStatus,
  reasons,
  setShowModalVerificationStatus,
  kycRejectPop,
  kycLimit,
}) => {
  const { t } = useTranslation(['auth', 'common', 'onfidoKyc']);
  return (
    <>
      <div className="justify-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full mx-3 my-4 max-w-md">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white dark:bg-slate-800  dark:text-slate-200 outline-none focus:outline-none">
            {/*header*/}
            <div className="flex justify-between items-center py-3 px-6">
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                onClick={() => setShowModalVerificationStatus(false)}
              >
                <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
                  <CloseButtonSvgIcon />
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative px-6 flex-auto">
              <div className="text-center mb-3">
                {kycStatus === 4 ? (
                  <div className="clock">
                    <div className="minutes"></div>
                    <div className="hours"></div>
                  </div>
                ) : (
                  <ImageLoader
                    alt=""
                    src="/img/error-img.gif"
                    className="w-7/12 mx-auto rounded-md"
                  />
                )}
              </div>
              <h3 className="text-center font-bold text-xl max-w-xs mx-auto">
                {kycStatus === 4
                  ? t('common:kyc_in_review')
                  : t('common:kyc_verification_failed')}
              </h3>
              <p className="text-center font-medium text-sm max-w-xs mx-auto text-gray-700 leading-6 my-5">
                {kycStatus === 4
                  ? t('common:due_to_reasons_below')
                  : t('onfidoKyc:your_kyc_verification_failed')}
              </p>
              <ul className="mt-6  max-w-[340px] mx-auto">
                {reasons?.length > 0 &&
                  reasons.map((reason, index) => {
                    const formattedReason = reason
                      .toLowerCase()
                      .replace(/_/g, ' ')
                      .replace(/^\w/, (c) => c.toUpperCase());
                    return (
                      <li
                        key={index}
                        className="flex gap-2 items-start text-sm text-gray-600 mb-2 relative pl-6"
                      >
                        <div className="w-1.5 h-1.5 rounded-full bg-gray-400 absolute left-0 top-2"></div>
                        {formattedReason}{' '}
                      </li>
                    );
                  })}
                {kycLimit && kycLimit >= 2 ? (
                  <li className="flex gap-2 items-start text-sm text-red-600 mb-2 relative pl-6">
                    <div className="w-1.5 h-1.5 rounded-full bg-red-400 absolute left-0 top-2"></div>

                    {t('common:kyc_attempt_reached')}
                  </li>
                ) : (
                  ''
                )}
              </ul>
            </div>
            {kycStatus === 4 || (kycLimit && kycLimit >= 2) ? (
              <div className="py-6 px-6 text-center flex flex-col gap-2 justify-between">
                <button
                  onClick={() => setShowModalVerificationStatus(false)}
                  className="bg-GreenColor active:bg-[#92C24B] w-full text-brandBlue border border-GreenColor font-bold uppercase text-sm px-6 py-3 rounded-lg  inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Ok
                </button>
              </div>
            ) : (
              <div className="py-6 px-6 text-center flex gap-2 justify-between">
                <button
                  onClick={() => kycRejectPop()}
                  className="bg-GreenColor active:bg-[#92C24B] w-full text-brandBlue border border-GreenColor font-bold uppercase text-sm px-3 py-3 rounded-lg  inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  {t('common:try_again')}
                </button>
                <button
                  className="bg-white active:bg-[#92C24B] w-full text-brandBlue border border-gray-300 font-bold uppercase text-sm px-3 py-3 rounded-lg inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowModalVerificationStatus(false)}
                >
                  Later
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};
export default VerificationFailed;
